import React, { useEffect, useRef, useState } from "react";
import { useGetBreedingFarmListQuery } from "../../../redux/api/breedingFarm/breedingFarmApi";
import { EntBreedingFarmFilter } from "../../../models/filters/breedingFarmFilter";
import { EntBreedingFarm } from "../../../models/breedingFarm";
import { MapContainer, TileLayer, GeoJSON, Marker, Popup, useMap } from "react-leaflet";
import { LatLngTuple } from "leaflet";
import L from "leaflet";
import { Table } from "antd";
import "antd/dist/reset.css"; 
import styles from "./styles_map.module.css";


const customMarkerIcon = L.icon({
  iconUrl: "/factory.svg",
  iconSize: [35, 55],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

interface IContentPart {
  latitude: number;
  longitude: number;
}

const MoveToMarker = ({ position }: { position: LatLngTuple }) => {
  const map = useMap();
  useEffect(() => {
    if (position) {
      map.setView(position, 14); 
    }
  }, [position, map]);
  return null;
};

export const BreedingPlantsMap = (props: IContentPart) => {
  const [geoData, setGeoData] = useState<any>(null);
  const [farms, setFarms] = useState<EntBreedingFarm[]>([]);
  const [selectedFarm, setSelectedFarm] = useState<LatLngTuple | null>(null);

  const filter: EntBreedingFarmFilter = {
    name: null,
    farmsStatusId: null,
    animalBreedIds: null,
    animalTypeIds: null,
    areaIds: null,
    regionIds: null,
    ownerId: null,
    address: null,
    createdFrom: null,
    createdTo: null,
    deleted: false,
    page: 1,
    size: 100,
  };

  const { data } = useGetBreedingFarmListQuery(filter);

  useEffect(() => {
    const fetchGeoData = async (file: string) => {
      try {
        const response = await fetch(`/${file}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data[0] && data[0].geojson) {
          setGeoData(data[0].geojson);
        }
      } catch (error) {
        console.error("Ошибка загрузки данных:", error);
      }
    };

    fetchGeoData("polygons/search.json");
  }, []);

  useEffect(() => {
    if (data) {
      const breedingFarmData = data.res?.content;
      if (breedingFarmData) {
        setFarms(breedingFarmData);
      }
    }
  }, [data]);

  const getStyle = (color: string) => ({
    color: color,
    weight: 2,
    opacity: 1,
    fillOpacity: 0.5,
  });

  const onEachFeature = (feature: any, layer: any) => {
    layer.on({
      mouseover: (e: any) => {
        e.target.setStyle({
          weight: 4,
          fillOpacity: 0.7,
        });
      },
      mouseout: (e: any) => {
        e.target.setStyle({
          weight: 2,
          fillOpacity: 0.5,
        });
      },
    });
  };

 
  const columns = [
    {
      title: "Название",
      dataIndex: "nameRu",
      key: "nameRu",
      render: (text: string, record: EntBreedingFarm) => (
        <button
          onClick={() => {
            if (record.latitude && record.longitude) {
              setSelectedFarm([record.latitude, record.longitude]);
            }
          }}
          className={styles.linkButton}
        >
          {text}
        </button>
      ),
    },
  ];

  return (
    <div className={styles.container}>
      <MapContainer
        className={styles.map}
        center={[41.5089324, 74.724091]}
        zoom={7}
        minZoom={7}
        scrollWheelZoom={true}
      >
    <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
  
        {geoData && (
          <GeoJSON
            data={geoData}
            style={getStyle("grey")}
            onEachFeature={onEachFeature}
          />
        )}
  
        {farms.map((farm) => (
          <Marker
            key={farm.id}
            position={[farm.latitude || 0, farm.longitude || 0] as LatLngTuple}
            icon={customMarkerIcon}
          >
 <Popup>
            <div>
              <h3>{farm.nameRu}</h3>
              <p>Район: {farm.area?.nameRu || "Район не указан"}</p>
              <p>Адрес: {farm?.address || "Адрес не указан"}</p>

              <p>
                Вид Животных:{" "}
                {farm.animalBreeds?.length
                  ? farm.animalBreeds.map((breed, index) => {
                      return (
                        <span key={index}>
                          {breed.animalType?.nameRu || "Не указан"}
                          {index < (farm.animalBreeds?.length || 0) - 1
                            ? ", "
                            : ""}
                        </span>
                      );
                    })
                  : "Виды животных не указаны"}
              </p>

              <p>Статус: {farm.farmsStatus?.nameRu || "Статус не указан"}</p>
              {/* <p>
                ФИО:{" "}
                {farm.owner?.name &&
                farm.owner?.secondName &&
                farm.owner?.patronymic
                  ? ${farm.owner.name} ${farm.owner.secondName} ${farm.owner.patronymic}
                  : "ФИО не указан"}
              </p> */}
            </div>
          </Popup>
          </Marker>
        ))}
  
        {selectedFarm && <MoveToMarker position={selectedFarm} />}
      </MapContainer>
  
      <div className={styles.tableContainer}>
        <div className={styles.tableTitle}>Список объектов</div>
        <Table
          dataSource={farms}
          columns={columns}
          rowKey={(record) => record.id}
          pagination={{ pageSize: 10 }}
        />
      </div>
    </div>
  );
  
  
  
};
